import DatatablesController from "../datatables_controller"

export default class WebsiteScreenshotsController extends DatatablesController {
}
